export const page11 = {
  "name": "page11",
  "title": "Addictions",
  "elements": [
    {
      "type": "rating",
      "name": "smoking",
      "title": "Do you smoke any tabacco products? If so, in what amounts?",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "40 cigarettes or more"
        },
        {
          "value": 2,
          "text": "20–39 cigarettes"
        },
        {
          "value": 3,
          "text": "10–19 cigarettes"
        },
        {
          "value": 4,
          "text": "1–9 cigarettes"
        },
        {
          "value": 5,
          "text": "I don't smoke"
        }
      ]
    },
    {
      "type": "rating",
      "name": "smoking_cut_down",
      "visibleIf": "{smoking} < 5",
      "title": "Do you wish to cut down on smoking?",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "No"
        },
        {
          "value": 2,
          "text": "Probably not"
        },
        {
          "value": 3,
          "text": "Probably not"
        },
        {
          "value": 4,
          "text": "Probably yes"
        },
        {
          "value": 5,
          "text": "Yes"
        }
      ]
    },
    {
      "type": "rating",
      "name": "alcohol_consumption",
      "title": "How often do you consume alcohol per week?",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Every day"
        },
        {
          "value": 2,
          "text": "5–6 days a week"
        },
        {
          "value": 3,
          "text": "3–4 days a week"
        },
        {
          "value": 4,
          "text": "1–2 days a week"
        },
        {
          "value": 5,
          "text": "Never"
        }
      ]
    }
  ]
};